var map = {
	"./cs.json": [
		38168,
		3,
		38168
	],
	"./cs/Account.json": [
		79072,
		3,
		79072
	],
	"./cs/AdvancedWidgets.json": [
		10238,
		3,
		10238
	],
	"./cs/Agencies.json": [
		62140,
		3,
		62140
	],
	"./cs/Analytics.json": [
		23080,
		3,
		23080
	],
	"./cs/AutoQA.json": [
		23982,
		3,
		23982
	],
	"./cs/BulkOrderPicker.json": [
		98710,
		3,
		98710
	],
	"./cs/Common.json": [
		94560,
		3,
		94560
	],
	"./cs/ConfigurationWizard.json": [
		25696,
		3,
		25696
	],
	"./cs/Core/Errors.json": [
		22318,
		3,
		22318
	],
	"./cs/Core/Footer.json": [
		41864,
		3,
		41864
	],
	"./cs/Core/Recurring.json": [
		90792,
		3,
		90792
	],
	"./cs/Core/Toolbar.json": [
		93028,
		3,
		93028
	],
	"./cs/Coupons.json": [
		50256,
		3,
		27876
	],
	"./cs/CreatorTemplate.json": [
		85692,
		3,
		85692
	],
	"./cs/CustomizePlugin.json": [
		65704,
		3,
		65704
	],
	"./cs/Drawer.json": [
		75432,
		3,
		75432
	],
	"./cs/Email.json": [
		1264,
		3,
		1264
	],
	"./cs/GroupAdd.json": [
		16102,
		3,
		16102
	],
	"./cs/GroupEdit.json": [
		11104,
		3,
		11104
	],
	"./cs/HelpAndTutorials.json": [
		65960,
		3,
		65960
	],
	"./cs/HelpVideos.json": [
		29392,
		3,
		29392
	],
	"./cs/Home.json": [
		44532,
		3,
		44532
	],
	"./cs/ImportReviews.json": [
		66394,
		3,
		66394
	],
	"./cs/Integration.json": [
		20388,
		3,
		20388
	],
	"./cs/LinkProducts.json": [
		1880,
		3,
		1880
	],
	"./cs/LinkShops.json": [
		74844,
		3,
		74844
	],
	"./cs/MigrateReviews.json": [
		76936,
		3,
		76936
	],
	"./cs/NewOnboarding.json": [
		86072,
		3,
		86072
	],
	"./cs/Onboarding.json": [
		80534,
		3,
		80534
	],
	"./cs/Permissions.json": [
		17392,
		3,
		17392
	],
	"./cs/PlanPicker.json": [
		55848,
		3,
		55848
	],
	"./cs/Questions.json": [
		62848,
		3,
		62848
	],
	"./cs/Referral.json": [
		86504,
		3,
		86504
	],
	"./cs/RequestViaLink.json": [
		77592,
		3,
		77592
	],
	"./cs/ReviewCard.json": [
		36194,
		3,
		36194
	],
	"./cs/ReviewRequests.json": [
		13794,
		3,
		13794
	],
	"./cs/ReviewRequestsConfiguration.json": [
		248,
		3,
		248
	],
	"./cs/Reviews.json": [
		56408,
		3,
		56408
	],
	"./cs/Seo.json": [
		35680,
		3,
		35680
	],
	"./cs/Settings.json": [
		43384,
		3,
		43384
	],
	"./cs/ShopReviews.json": [
		23622,
		3,
		23622
	],
	"./cs/SmartReviews.json": [
		49152,
		3,
		49152
	],
	"./cs/TeamMembers.json": [
		99576,
		3,
		77196
	],
	"./cs/Welcome.json": [
		24136,
		3,
		24136
	],
	"./cs/Widgets.json": [
		70448,
		3,
		70448
	],
	"./cs/getStarted.json": [
		40832,
		3,
		40832
	],
	"./cz.json": [
		40064,
		3,
		17684
	],
	"./cz/Account.json": [
		83448,
		3,
		83448
	],
	"./cz/AdvancedWidgets.json": [
		87440,
		3,
		65056
	],
	"./cz/Agencies.json": [
		45992,
		3,
		45992
	],
	"./cz/Analytics.json": [
		44644,
		3,
		44644
	],
	"./cz/AutoQA.json": [
		58432,
		3,
		58432
	],
	"./cz/BulkOrderPicker.json": [
		76820,
		3,
		76820
	],
	"./cz/Common.json": [
		54052,
		3,
		54052
	],
	"./cz/ConfigurationWizard.json": [
		18640,
		3,
		18640
	],
	"./cz/Core/Errors.json": [
		99896,
		3,
		99896
	],
	"./cz/Core/Footer.json": [
		87640,
		3,
		87640
	],
	"./cz/Core/Recurring.json": [
		30694,
		3,
		30694
	],
	"./cz/Core/Toolbar.json": [
		64232,
		3,
		64232
	],
	"./cz/Coupons.json": [
		39484,
		3,
		39484
	],
	"./cz/CreatorTemplate.json": [
		85350,
		3,
		85350
	],
	"./cz/CustomizePlugin.json": [
		19760,
		3,
		19760
	],
	"./cz/Drawer.json": [
		16440,
		3,
		16440
	],
	"./cz/Email.json": [
		65060,
		3,
		87440
	],
	"./cz/GroupAdd.json": [
		35184,
		3,
		35184
	],
	"./cz/GroupEdit.json": [
		7944,
		3,
		7944
	],
	"./cz/HelpAndTutorials.json": [
		800,
		3,
		800
	],
	"./cz/HelpVideos.json": [
		29252,
		3,
		51632
	],
	"./cz/Home.json": [
		34608,
		3,
		34608
	],
	"./cz/ImportReviews.json": [
		51232,
		3,
		51232
	],
	"./cz/Integration.json": [
		38272,
		3,
		38272
	],
	"./cz/LinkProducts.json": [
		7368,
		3,
		7368
	],
	"./cz/LinkShops.json": [
		52456,
		3,
		52456
	],
	"./cz/MigrateReviews.json": [
		75544,
		3,
		53164
	],
	"./cz/NewOnboarding.json": [
		24986,
		3,
		24986
	],
	"./cz/Onboarding.json": [
		39736,
		3,
		39736
	],
	"./cz/Permissions.json": [
		31736,
		3,
		31736
	],
	"./cz/PlanPicker.json": [
		55440,
		3,
		55440
	],
	"./cz/Questions.json": [
		44624,
		3,
		44624
	],
	"./cz/Referral.json": [
		11768,
		3,
		11768
	],
	"./cz/RequestViaLink.json": [
		14088,
		3,
		14088
	],
	"./cz/ReviewCard.json": [
		25464,
		3,
		25464
	],
	"./cz/ReviewRequests.json": [
		20368,
		3,
		20368
	],
	"./cz/ReviewRequestsConfiguration.json": [
		84864,
		3,
		84864
	],
	"./cz/Reviews.json": [
		37392,
		3,
		37392
	],
	"./cz/Seo.json": [
		60575,
		3,
		60575
	],
	"./cz/Settings.json": [
		18752,
		3,
		18752
	],
	"./cz/ShopReviews.json": [
		46678,
		3,
		46678
	],
	"./cz/SmartReviews.json": [
		95096,
		3,
		95096
	],
	"./cz/TeamMembers.json": [
		32298,
		3,
		32298
	],
	"./cz/Welcome.json": [
		93860,
		3,
		93860
	],
	"./cz/Widgets.json": [
		92384,
		3,
		92384
	],
	"./cz/getStarted.json": [
		97036,
		3,
		97036
	],
	"./da.json": [
		33306,
		3,
		33306
	],
	"./da/Account.json": [
		7200,
		3,
		7200
	],
	"./da/AdvancedWidgets.json": [
		2656,
		3,
		2656
	],
	"./da/Agencies.json": [
		24024,
		3,
		24024
	],
	"./da/Analytics.json": [
		72642,
		3,
		72642
	],
	"./da/AutoQA.json": [
		46000,
		3,
		46000
	],
	"./da/BulkOrderPicker.json": [
		16214,
		3,
		16214
	],
	"./da/Common.json": [
		97336,
		3,
		97336
	],
	"./da/ConfigurationWizard.json": [
		23536,
		3,
		23536
	],
	"./da/Core/Errors.json": [
		63248,
		3,
		63248
	],
	"./da/Core/Footer.json": [
		8080,
		3,
		8080
	],
	"./da/Core/Recurring.json": [
		20888,
		3,
		20888
	],
	"./da/Core/Toolbar.json": [
		76336,
		3,
		76336
	],
	"./da/Coupons.json": [
		67364,
		3,
		67364
	],
	"./da/CreatorTemplate.json": [
		26776,
		3,
		26776
	],
	"./da/CustomizePlugin.json": [
		68760,
		3,
		68760
	],
	"./da/Drawer.json": [
		89784,
		3,
		89784
	],
	"./da/Email.json": [
		2680,
		3,
		2680
	],
	"./da/GroupAdd.json": [
		25400,
		3,
		25400
	],
	"./da/GroupEdit.json": [
		50584,
		3,
		50584
	],
	"./da/HelpAndTutorials.json": [
		33176,
		3,
		33176
	],
	"./da/HelpVideos.json": [
		53104,
		3,
		53104
	],
	"./da/Home.json": [
		96488,
		3,
		96488
	],
	"./da/ImportReviews.json": [
		11990,
		3,
		11990
	],
	"./da/Integration.json": [
		93088,
		3,
		93088
	],
	"./da/LinkProducts.json": [
		51208,
		3,
		28827
	],
	"./da/LinkShops.json": [
		62536,
		3,
		62536
	],
	"./da/MigrateReviews.json": [
		5394,
		3,
		5394
	],
	"./da/NewOnboarding.json": [
		64118,
		3,
		64118
	],
	"./da/Onboarding.json": [
		90336,
		3,
		90336
	],
	"./da/Permissions.json": [
		58626,
		3,
		58626
	],
	"./da/PlanPicker.json": [
		25822,
		3,
		25822
	],
	"./da/Questions.json": [
		76544,
		3,
		54164
	],
	"./da/Referral.json": [
		93500,
		3,
		93500
	],
	"./da/RequestViaLink.json": [
		57627,
		3,
		57627
	],
	"./da/ReviewCard.json": [
		72544,
		3,
		72544
	],
	"./da/ReviewRequests.json": [
		55472,
		3,
		55472
	],
	"./da/ReviewRequestsConfiguration.json": [
		35776,
		3,
		35776
	],
	"./da/Reviews.json": [
		37438,
		3,
		37438
	],
	"./da/Seo.json": [
		61216,
		3,
		61216
	],
	"./da/Settings.json": [
		64128,
		3,
		41748
	],
	"./da/ShopReviews.json": [
		54646,
		3,
		54646
	],
	"./da/SmartReviews.json": [
		92416,
		3,
		92416
	],
	"./da/TeamMembers.json": [
		32376,
		3,
		32376
	],
	"./da/Welcome.json": [
		92976,
		3,
		92976
	],
	"./da/Widgets.json": [
		64488,
		3,
		64488
	],
	"./da/getStarted.json": [
		97136,
		3,
		97136
	],
	"./de.json": [
		12138,
		3,
		12138
	],
	"./de/Account.json": [
		48418,
		3,
		48418
	],
	"./de/AdvancedWidgets.json": [
		45856,
		3,
		45856
	],
	"./de/Agencies.json": [
		88504,
		3,
		88504
	],
	"./de/Analytics.json": [
		14454,
		3,
		14454
	],
	"./de/AutoQA.json": [
		25056,
		3,
		25056
	],
	"./de/BulkOrderPicker.json": [
		52054,
		3,
		52054
	],
	"./de/Common.json": [
		17538,
		3,
		17538
	],
	"./de/ConfigurationWizard.json": [
		46328,
		3,
		23948
	],
	"./de/Core/Errors.json": [
		14888,
		3,
		14888
	],
	"./de/Core/Footer.json": [
		96344,
		3,
		96344
	],
	"./de/Core/Recurring.json": [
		82564,
		3,
		4944
	],
	"./de/Core/Toolbar.json": [
		65648,
		3,
		65648
	],
	"./de/Coupons.json": [
		5240,
		3,
		5240
	],
	"./de/CreatorTemplate.json": [
		68502,
		3,
		68502
	],
	"./de/CustomizePlugin.json": [
		16280,
		3,
		16280
	],
	"./de/Drawer.json": [
		29430,
		3,
		29430
	],
	"./de/Email.json": [
		53928,
		3,
		53928
	],
	"./de/GroupAdd.json": [
		9366,
		3,
		9366
	],
	"./de/GroupEdit.json": [
		65232,
		3,
		65232
	],
	"./de/HelpAndTutorials.json": [
		84020,
		3,
		84020
	],
	"./de/HelpVideos.json": [
		51906,
		3,
		51906
	],
	"./de/Home.json": [
		15500,
		3,
		15500
	],
	"./de/ImportReviews.json": [
		90104,
		3,
		67724
	],
	"./de/Integration.json": [
		65920,
		3,
		65920
	],
	"./de/LinkProducts.json": [
		54528,
		3,
		54528
	],
	"./de/LinkShops.json": [
		71952,
		3,
		71952
	],
	"./de/MigrateReviews.json": [
		83224,
		3,
		83224
	],
	"./de/NewOnboarding.json": [
		65472,
		3,
		65472
	],
	"./de/Onboarding.json": [
		31600,
		3,
		31600
	],
	"./de/Permissions.json": [
		792,
		3,
		792
	],
	"./de/PlanPicker.json": [
		51032,
		3,
		51032
	],
	"./de/Questions.json": [
		41288,
		3,
		41288
	],
	"./de/Referral.json": [
		47270,
		3,
		47270
	],
	"./de/RequestViaLink.json": [
		79584,
		3,
		79584
	],
	"./de/ReviewCard.json": [
		3288,
		3,
		3288
	],
	"./de/ReviewRequests.json": [
		38778,
		3,
		38778
	],
	"./de/ReviewRequestsConfiguration.json": [
		90408,
		3,
		90408
	],
	"./de/Reviews.json": [
		54164,
		3,
		76544
	],
	"./de/Seo.json": [
		9312,
		3,
		9312
	],
	"./de/Settings.json": [
		80632,
		3,
		80632
	],
	"./de/ShopReviews.json": [
		17888,
		3,
		17888
	],
	"./de/SmartReviews.json": [
		70504,
		3,
		70504
	],
	"./de/TeamMembers.json": [
		7304,
		3,
		7304
	],
	"./de/Welcome.json": [
		25528,
		3,
		25528
	],
	"./de/Widgets.json": [
		91538,
		3,
		91538
	],
	"./de/getStarted.json": [
		59384,
		3,
		59384
	],
	"./en.json": [
		61976,
		3
	],
	"./en/Account.json": [
		71144,
		3,
		71144
	],
	"./en/AdvancedWidgets.json": [
		34384,
		3,
		34384
	],
	"./en/Agencies.json": [
		45872,
		3,
		45872
	],
	"./en/Analytics.json": [
		83700,
		3,
		83700
	],
	"./en/AutoQA.json": [
		84000,
		3,
		84000
	],
	"./en/BulkOrderPicker.json": [
		41132,
		3,
		41132
	],
	"./en/Common.json": [
		62464,
		3,
		62464
	],
	"./en/ConfigurationWizard.json": [
		84070,
		3,
		84070
	],
	"./en/Core/Errors.json": [
		27160,
		3,
		27160
	],
	"./en/Core/Footer.json": [
		40264,
		3,
		40264
	],
	"./en/Core/Recurring.json": [
		32472,
		3,
		10092
	],
	"./en/Core/Toolbar.json": [
		84624,
		3,
		84624
	],
	"./en/Coupons.json": [
		91983,
		3,
		91983
	],
	"./en/CreatorTemplate.json": [
		19942,
		3,
		19942
	],
	"./en/CustomizePlugin.json": [
		62384,
		3,
		62384
	],
	"./en/Drawer.json": [
		29620,
		3,
		29620
	],
	"./en/Email.json": [
		88560,
		3,
		88560
	],
	"./en/GroupAdd.json": [
		84920,
		3,
		84920
	],
	"./en/GroupEdit.json": [
		80280,
		3,
		80280
	],
	"./en/HelpAndTutorials.json": [
		32192,
		3,
		32192
	],
	"./en/HelpVideos.json": [
		17000,
		3,
		17000
	],
	"./en/Home.json": [
		4880,
		3,
		4880
	],
	"./en/ImportReviews.json": [
		95634,
		3,
		95634
	],
	"./en/Integration.json": [
		45488,
		3,
		23108
	],
	"./en/LinkProducts.json": [
		22532,
		3,
		44912
	],
	"./en/LinkShops.json": [
		92764,
		3,
		92764
	],
	"./en/MigrateReviews.json": [
		5040,
		3,
		5040
	],
	"./en/NewOnboarding.json": [
		21248,
		3,
		21248
	],
	"./en/Onboarding.json": [
		92272,
		3,
		92272
	],
	"./en/Permissions.json": [
		88584,
		3,
		88584
	],
	"./en/PlanPicker.json": [
		59128,
		3,
		59128
	],
	"./en/Questions.json": [
		90312,
		3,
		90312
	],
	"./en/Referral.json": [
		88200,
		3,
		88200
	],
	"./en/RequestViaLink.json": [
		16356,
		3,
		16356
	],
	"./en/ReviewCard.json": [
		61240,
		3,
		61240
	],
	"./en/ReviewRequests.json": [
		77450,
		3,
		77450
	],
	"./en/ReviewRequestsConfiguration.json": [
		88836,
		3,
		88836
	],
	"./en/Reviews.json": [
		40112,
		3,
		40112
	],
	"./en/Seo.json": [
		30424,
		3,
		30424
	],
	"./en/Settings.json": [
		88976,
		3,
		88976
	],
	"./en/ShopReviews.json": [
		12864,
		3,
		12864
	],
	"./en/SmartReviews.json": [
		72660,
		3,
		72660
	],
	"./en/TeamMembers.json": [
		57344,
		3,
		57344
	],
	"./en/Welcome.json": [
		47116,
		3,
		47116
	],
	"./en/Widgets.json": [
		79056,
		3,
		79056
	],
	"./en/getStarted.json": [
		58640,
		3,
		58640
	],
	"./es.json": [
		62850,
		3,
		62850
	],
	"./es/Account.json": [
		84608,
		3,
		84608
	],
	"./es/AdvancedWidgets.json": [
		77312,
		3,
		77312
	],
	"./es/Agencies.json": [
		64224,
		3,
		64224
	],
	"./es/Analytics.json": [
		24240,
		3,
		1860
	],
	"./es/AutoQA.json": [
		35648,
		3,
		35648
	],
	"./es/BulkOrderPicker.json": [
		0,
		3,
		0
	],
	"./es/Common.json": [
		30974,
		3,
		30974
	],
	"./es/ConfigurationWizard.json": [
		49556,
		3,
		49556
	],
	"./es/Core/Errors.json": [
		80704,
		3,
		80704
	],
	"./es/Core/Footer.json": [
		71394,
		3,
		71394
	],
	"./es/Core/Recurring.json": [
		12835,
		3,
		35216
	],
	"./es/Core/Toolbar.json": [
		76984,
		3,
		76984
	],
	"./es/Core/enjoyingOpinew.json": [
		64374,
		1,
		64374
	],
	"./es/Core/rateYourExperience.json": [
		99752,
		1,
		77372
	],
	"./es/Coupons.json": [
		49059,
		3,
		71440
	],
	"./es/CreatorTemplate.json": [
		82952,
		3,
		82952
	],
	"./es/CustomizePlugin.json": [
		20164,
		3,
		20164
	],
	"./es/Drawer.json": [
		64864,
		3,
		64864
	],
	"./es/Email.json": [
		58488,
		3,
		58488
	],
	"./es/GroupAdd.json": [
		83982,
		3,
		83982
	],
	"./es/GroupEdit.json": [
		9516,
		3,
		9516
	],
	"./es/HelpAndTutorials.json": [
		82568,
		3,
		82568
	],
	"./es/HelpVideos.json": [
		99296,
		3,
		99296
	],
	"./es/Home.json": [
		29068,
		3,
		29068
	],
	"./es/ImportReviews.json": [
		54632,
		3,
		54632
	],
	"./es/Integration.json": [
		50555,
		3,
		50555
	],
	"./es/LinkProducts.json": [
		96176,
		3,
		96176
	],
	"./es/LinkShops.json": [
		15436,
		3,
		15436
	],
	"./es/MigrateReviews.json": [
		17924,
		3,
		17924
	],
	"./es/NewOnboarding.json": [
		560,
		3,
		560
	],
	"./es/Onboarding.json": [
		48502,
		3,
		48502
	],
	"./es/Permissions.json": [
		14424,
		3,
		14424
	],
	"./es/PlanPicker.json": [
		8728,
		3,
		8728
	],
	"./es/Questions.json": [
		59484,
		3,
		59484
	],
	"./es/Referral.json": [
		19336,
		3,
		19336
	],
	"./es/RequestViaLink.json": [
		47864,
		3,
		47864
	],
	"./es/ReviewCard.json": [
		18704,
		3,
		18704
	],
	"./es/ReviewRequests.json": [
		28044,
		3,
		28044
	],
	"./es/ReviewRequestsConfiguration.json": [
		93044,
		3,
		15424
	],
	"./es/Reviews.json": [
		65812,
		3,
		65812
	],
	"./es/Seo.json": [
		73206,
		3,
		73206
	],
	"./es/Settings.json": [
		33292,
		3,
		33292
	],
	"./es/ShopReviews.json": [
		8360,
		3,
		8360
	],
	"./es/SmartReviews.json": [
		25260,
		3,
		25260
	],
	"./es/TeamMembers.json": [
		25320,
		3,
		25320
	],
	"./es/Welcome.json": [
		12820,
		3,
		12820
	],
	"./es/Widgets.json": [
		43086,
		3,
		43086
	],
	"./es/getStarted.json": [
		56704,
		3,
		56704
	],
	"./fi.json": [
		26112,
		3,
		3732
	],
	"./fi/Account.json": [
		84728,
		3,
		84728
	],
	"./fi/AdvancedWidgets.json": [
		13344,
		3,
		13344
	],
	"./fi/Agencies.json": [
		9408,
		3,
		9408
	],
	"./fi/Analytics.json": [
		43032,
		3,
		43032
	],
	"./fi/AutoQA.json": [
		88000,
		3,
		88000
	],
	"./fi/BulkOrderPicker.json": [
		14146,
		3,
		14146
	],
	"./fi/Common.json": [
		94028,
		3,
		94028
	],
	"./fi/ConfigurationWizard.json": [
		10304,
		3,
		10304
	],
	"./fi/Core/Errors.json": [
		41748,
		3,
		64128
	],
	"./fi/Core/Footer.json": [
		92059,
		3,
		92059
	],
	"./fi/Core/Recurring.json": [
		78308,
		3,
		78308
	],
	"./fi/Core/Toolbar.json": [
		29936,
		3,
		29936
	],
	"./fi/Coupons.json": [
		36914,
		3,
		36914
	],
	"./fi/CreatorTemplate.json": [
		15018,
		3,
		15018
	],
	"./fi/CustomizePlugin.json": [
		73100,
		3,
		73100
	],
	"./fi/Drawer.json": [
		93192,
		3,
		93192
	],
	"./fi/Email.json": [
		30274,
		3,
		30274
	],
	"./fi/GroupAdd.json": [
		12092,
		3,
		12092
	],
	"./fi/GroupEdit.json": [
		8464,
		3,
		8464
	],
	"./fi/HelpAndTutorials.json": [
		36312,
		3,
		36312
	],
	"./fi/HelpVideos.json": [
		39356,
		3,
		39356
	],
	"./fi/Home.json": [
		70920,
		3,
		70920
	],
	"./fi/ImportReviews.json": [
		58416,
		3,
		58416
	],
	"./fi/Integration.json": [
		90820,
		3,
		90820
	],
	"./fi/LinkProducts.json": [
		21192,
		3,
		21192
	],
	"./fi/LinkShops.json": [
		13328,
		3,
		13328
	],
	"./fi/MigrateReviews.json": [
		36960,
		3,
		36960
	],
	"./fi/NewOnboarding.json": [
		59370,
		3,
		59370
	],
	"./fi/Onboarding.json": [
		94744,
		3,
		94744
	],
	"./fi/Permissions.json": [
		61862,
		3,
		61862
	],
	"./fi/PlanPicker.json": [
		98718,
		3,
		98718
	],
	"./fi/Questions.json": [
		29956,
		3,
		29956
	],
	"./fi/Referral.json": [
		66216,
		3,
		66216
	],
	"./fi/RequestViaLink.json": [
		51180,
		3,
		51180
	],
	"./fi/ReviewCard.json": [
		94732,
		3,
		94732
	],
	"./fi/ReviewRequests.json": [
		58988,
		3,
		58988
	],
	"./fi/ReviewRequestsConfiguration.json": [
		58208,
		3,
		58208
	],
	"./fi/Reviews.json": [
		80160,
		3,
		80160
	],
	"./fi/Seo.json": [
		26400,
		3,
		4019
	],
	"./fi/Settings.json": [
		37526,
		3,
		37526
	],
	"./fi/ShopReviews.json": [
		17520,
		3,
		17520
	],
	"./fi/SmartReviews.json": [
		55696,
		3,
		55696
	],
	"./fi/TeamMembers.json": [
		26220,
		3,
		26220
	],
	"./fi/Welcome.json": [
		3616,
		3,
		3616
	],
	"./fi/Widgets.json": [
		31560,
		3,
		31560
	],
	"./fi/getStarted.json": [
		28082,
		3,
		28082
	],
	"./fr.json": [
		11596,
		3,
		11596
	],
	"./fr/Account.json": [
		82048,
		3,
		82048
	],
	"./fr/AdvancedWidgets.json": [
		95168,
		3,
		95168
	],
	"./fr/Agencies.json": [
		54352,
		3,
		54352
	],
	"./fr/Analytics.json": [
		41874,
		3,
		41874
	],
	"./fr/AutoQA.json": [
		29598,
		3,
		29598
	],
	"./fr/BulkOrderPicker.json": [
		56016,
		3,
		56016
	],
	"./fr/Common.json": [
		77872,
		3,
		77872
	],
	"./fr/ConfigurationWizard.json": [
		88280,
		3,
		88280
	],
	"./fr/Core/Errors.json": [
		42000,
		3,
		42000
	],
	"./fr/Core/Footer.json": [
		37039,
		3,
		37039
	],
	"./fr/Core/Recurring.json": [
		46656,
		3,
		46656
	],
	"./fr/Core/Toolbar.json": [
		12108,
		3,
		12108
	],
	"./fr/Coupons.json": [
		26908,
		3,
		26908
	],
	"./fr/CreatorTemplate.json": [
		53184,
		3,
		53184
	],
	"./fr/CustomizePlugin.json": [
		736,
		3,
		736
	],
	"./fr/Drawer.json": [
		14200,
		3,
		14200
	],
	"./fr/Email.json": [
		5060,
		3,
		5060
	],
	"./fr/GroupAdd.json": [
		27674,
		3,
		27674
	],
	"./fr/GroupEdit.json": [
		20328,
		3,
		20328
	],
	"./fr/HelpAndTutorials.json": [
		27648,
		3,
		27648
	],
	"./fr/HelpVideos.json": [
		92720,
		3,
		92720
	],
	"./fr/Home.json": [
		23486,
		3,
		23486
	],
	"./fr/ImportReviews.json": [
		49590,
		3,
		49590
	],
	"./fr/Integration.json": [
		81328,
		3,
		58948
	],
	"./fr/LinkProducts.json": [
		29060,
		3,
		29060
	],
	"./fr/LinkShops.json": [
		62648,
		3,
		62648
	],
	"./fr/MigrateReviews.json": [
		28208,
		3,
		28208
	],
	"./fr/NewOnboarding.json": [
		23684,
		3,
		23684
	],
	"./fr/Onboarding.json": [
		29864,
		3,
		29864
	],
	"./fr/Permissions.json": [
		12690,
		3,
		12690
	],
	"./fr/PlanPicker.json": [
		44544,
		3,
		44544
	],
	"./fr/Questions.json": [
		69994,
		3,
		69994
	],
	"./fr/Referral.json": [
		37248,
		3,
		37248
	],
	"./fr/RequestViaLink.json": [
		88216,
		3,
		88216
	],
	"./fr/ReviewCard.json": [
		69042,
		3,
		69042
	],
	"./fr/ReviewRequests.json": [
		64676,
		3,
		64676
	],
	"./fr/ReviewRequestsConfiguration.json": [
		81512,
		3,
		81512
	],
	"./fr/Reviews.json": [
		94848,
		3,
		94848
	],
	"./fr/Seo.json": [
		22752,
		3,
		22752
	],
	"./fr/Settings.json": [
		29960,
		3,
		29960
	],
	"./fr/ShopReviews.json": [
		61960,
		3,
		61960
	],
	"./fr/SmartReviews.json": [
		16660,
		3,
		39040
	],
	"./fr/TeamMembers.json": [
		28608,
		3,
		28608
	],
	"./fr/Welcome.json": [
		72168,
		3,
		72168
	],
	"./fr/Widgets.json": [
		31088,
		3,
		31088
	],
	"./fr/getStarted.json": [
		96038,
		3,
		96038
	],
	"./it.json": [
		59592,
		3,
		59592
	],
	"./it/Account.json": [
		27942,
		3,
		27942
	],
	"./it/AdvancedWidgets.json": [
		20400,
		3,
		20400
	],
	"./it/Agencies.json": [
		66934,
		3,
		66934
	],
	"./it/Analytics.json": [
		64722,
		3,
		64722
	],
	"./it/AutoQA.json": [
		84560,
		3,
		84560
	],
	"./it/BulkOrderPicker.json": [
		22322,
		3,
		22322
	],
	"./it/Common.json": [
		54754,
		3,
		54754
	],
	"./it/ConfigurationWizard.json": [
		25872,
		3,
		25872
	],
	"./it/Core/Errors.json": [
		60432,
		3,
		60432
	],
	"./it/Core/Footer.json": [
		82126,
		3,
		82126
	],
	"./it/Core/Recurring.json": [
		2600,
		3,
		2600
	],
	"./it/Core/Toolbar.json": [
		68568,
		3,
		68568
	],
	"./it/Coupons.json": [
		65696,
		3,
		65696
	],
	"./it/CreatorTemplate.json": [
		7096,
		3,
		7096
	],
	"./it/CustomizePlugin.json": [
		54216,
		3,
		54216
	],
	"./it/Drawer.json": [
		46344,
		3,
		46344
	],
	"./it/Email.json": [
		53872,
		3,
		53872
	],
	"./it/GroupAdd.json": [
		34944,
		3,
		34944
	],
	"./it/GroupEdit.json": [
		69984,
		3,
		69984
	],
	"./it/HelpAndTutorials.json": [
		39972,
		3,
		39972
	],
	"./it/HelpVideos.json": [
		49776,
		3,
		49776
	],
	"./it/Home.json": [
		22656,
		3,
		22656
	],
	"./it/ImportReviews.json": [
		95234,
		3,
		95234
	],
	"./it/Integration.json": [
		69918,
		3,
		69918
	],
	"./it/LinkProducts.json": [
		81196,
		3,
		81196
	],
	"./it/LinkShops.json": [
		44688,
		3,
		44688
	],
	"./it/MigrateReviews.json": [
		43408,
		3,
		43408
	],
	"./it/NewOnboarding.json": [
		57528,
		3,
		57528
	],
	"./it/Onboarding.json": [
		33744,
		3,
		33744
	],
	"./it/Permissions.json": [
		59504,
		3,
		59504
	],
	"./it/PlanPicker.json": [
		27962,
		3,
		27962
	],
	"./it/Questions.json": [
		46234,
		3,
		46234
	],
	"./it/Referral.json": [
		35856,
		3,
		35856
	],
	"./it/RequestViaLink.json": [
		43992,
		3,
		43992
	],
	"./it/ReviewCard.json": [
		17304,
		3,
		17304
	],
	"./it/ReviewRequests.json": [
		94952,
		3,
		94952
	],
	"./it/ReviewRequestsConfiguration.json": [
		76408,
		3,
		76408
	],
	"./it/Reviews.json": [
		56644,
		3,
		56644
	],
	"./it/Seo.json": [
		60220,
		3,
		60220
	],
	"./it/Settings.json": [
		29464,
		3,
		29464
	],
	"./it/ShopReviews.json": [
		25284,
		3,
		25284
	],
	"./it/SmartReviews.json": [
		27304,
		3,
		27304
	],
	"./it/TeamMembers.json": [
		90296,
		3,
		67916
	],
	"./it/Welcome.json": [
		14532,
		3,
		14532
	],
	"./it/Widgets.json": [
		16064,
		3,
		16064
	],
	"./it/getStarted.json": [
		41192,
		3,
		41192
	],
	"./ja.json": [
		64464,
		3,
		64464
	],
	"./ja/Account.json": [
		47650,
		3,
		47650
	],
	"./ja/AdvancedWidgets.json": [
		29920,
		3,
		29920
	],
	"./ja/Agencies.json": [
		97584,
		3,
		97584
	],
	"./ja/Analytics.json": [
		55870,
		3,
		55870
	],
	"./ja/AutoQA.json": [
		9176,
		3,
		9176
	],
	"./ja/BulkOrderPicker.json": [
		22664,
		3,
		22664
	],
	"./ja/Common.json": [
		59236,
		3,
		36856
	],
	"./ja/ConfigurationWizard.json": [
		41624,
		3,
		41624
	],
	"./ja/Core/Errors.json": [
		99968,
		3,
		99968
	],
	"./ja/Core/Footer.json": [
		12104,
		3,
		12104
	],
	"./ja/Core/Recurring.json": [
		46440,
		3,
		46440
	],
	"./ja/Core/Toolbar.json": [
		40672,
		3,
		40672
	],
	"./ja/Coupons.json": [
		57104,
		3,
		57104
	],
	"./ja/CreatorTemplate.json": [
		1860,
		3,
		24240
	],
	"./ja/CustomizePlugin.json": [
		89512,
		3,
		89512
	],
	"./ja/Drawer.json": [
		19208,
		3,
		19208
	],
	"./ja/Email.json": [
		92004,
		3,
		92004
	],
	"./ja/GroupAdd.json": [
		92376,
		3,
		92376
	],
	"./ja/GroupEdit.json": [
		3864,
		3,
		3864
	],
	"./ja/HelpAndTutorials.json": [
		51672,
		3,
		51672
	],
	"./ja/HelpVideos.json": [
		84520,
		3,
		84520
	],
	"./ja/Home.json": [
		63788,
		3,
		63788
	],
	"./ja/ImportReviews.json": [
		12888,
		3,
		12888
	],
	"./ja/Integration.json": [
		90080,
		3,
		90080
	],
	"./ja/LinkProducts.json": [
		16398,
		3,
		16398
	],
	"./ja/LinkShops.json": [
		55948,
		3,
		55948
	],
	"./ja/MigrateReviews.json": [
		232,
		3,
		232
	],
	"./ja/NewOnboarding.json": [
		67430,
		3,
		67430
	],
	"./ja/Onboarding.json": [
		51792,
		3,
		51792
	],
	"./ja/Permissions.json": [
		38188,
		3,
		38188
	],
	"./ja/PlanPicker.json": [
		55392,
		3,
		55392
	],
	"./ja/Questions.json": [
		39986,
		3,
		39986
	],
	"./ja/Referral.json": [
		38624,
		3,
		38624
	],
	"./ja/RequestViaLink.json": [
		79256,
		3,
		79256
	],
	"./ja/ReviewCard.json": [
		44416,
		3,
		44416
	],
	"./ja/ReviewRequests.json": [
		56216,
		3,
		56216
	],
	"./ja/ReviewRequestsConfiguration.json": [
		89370,
		3,
		89370
	],
	"./ja/Reviews.json": [
		80210,
		3,
		80210
	],
	"./ja/Seo.json": [
		54708,
		3,
		54708
	],
	"./ja/Settings.json": [
		75368,
		3,
		75368
	],
	"./ja/ShopReviews.json": [
		21512,
		3,
		21512
	],
	"./ja/SmartReviews.json": [
		37504,
		3,
		37504
	],
	"./ja/TeamMembers.json": [
		13134,
		3,
		13134
	],
	"./ja/Welcome.json": [
		79360,
		3,
		79360
	],
	"./ja/Widgets.json": [
		71036,
		3,
		71036
	],
	"./ja/getStarted.json": [
		64852,
		3,
		64852
	],
	"./ko.json": [
		28528,
		3,
		28528
	],
	"./ko/Account.json": [
		95826,
		3,
		95826
	],
	"./ko/AdvancedWidgets.json": [
		30464,
		3,
		30464
	],
	"./ko/Agencies.json": [
		10504,
		3,
		10504
	],
	"./ko/Analytics.json": [
		48986,
		3,
		48986
	],
	"./ko/AutoQA.json": [
		1672,
		3,
		1672
	],
	"./ko/BulkOrderPicker.json": [
		73488,
		3,
		73488
	],
	"./ko/Common.json": [
		68882,
		3,
		68882
	],
	"./ko/ConfigurationWizard.json": [
		66062,
		3,
		66062
	],
	"./ko/Core/Errors.json": [
		25304,
		3,
		25304
	],
	"./ko/Core/Footer.json": [
		82758,
		3,
		82758
	],
	"./ko/Core/Recurring.json": [
		33008,
		3,
		33008
	],
	"./ko/Core/Toolbar.json": [
		48834,
		3,
		48834
	],
	"./ko/Coupons.json": [
		83942,
		3,
		83942
	],
	"./ko/CreatorTemplate.json": [
		8156,
		3,
		8156
	],
	"./ko/CustomizePlugin.json": [
		69772,
		3,
		69772
	],
	"./ko/Drawer.json": [
		86110,
		3,
		86110
	],
	"./ko/Email.json": [
		51828,
		3,
		51828
	],
	"./ko/GroupAdd.json": [
		4618,
		3,
		4618
	],
	"./ko/GroupEdit.json": [
		42344,
		3,
		42344
	],
	"./ko/HelpAndTutorials.json": [
		14106,
		3,
		14106
	],
	"./ko/HelpVideos.json": [
		8672,
		3,
		8672
	],
	"./ko/Home.json": [
		40410,
		3,
		40410
	],
	"./ko/ImportReviews.json": [
		84048,
		3,
		84048
	],
	"./ko/Integration.json": [
		15418,
		3,
		15418
	],
	"./ko/LinkProducts.json": [
		13438,
		3,
		13438
	],
	"./ko/LinkShops.json": [
		38288,
		3,
		38288
	],
	"./ko/MigrateReviews.json": [
		40288,
		3,
		40288
	],
	"./ko/NewOnboarding.json": [
		79008,
		3,
		79008
	],
	"./ko/Onboarding.json": [
		8052,
		3,
		8052
	],
	"./ko/Permissions.json": [
		37808,
		3,
		37808
	],
	"./ko/PlanPicker.json": [
		60776,
		3,
		60776
	],
	"./ko/Questions.json": [
		41832,
		3,
		41832
	],
	"./ko/Referral.json": [
		30864,
		3,
		8484
	],
	"./ko/RequestViaLink.json": [
		65416,
		3,
		65416
	],
	"./ko/ReviewCard.json": [
		76496,
		3,
		54116
	],
	"./ko/ReviewRequests.json": [
		54336,
		3,
		54336
	],
	"./ko/ReviewRequestsConfiguration.json": [
		61918,
		3,
		61918
	],
	"./ko/Reviews.json": [
		85818,
		3,
		85818
	],
	"./ko/Seo.json": [
		70072,
		3,
		70072
	],
	"./ko/Settings.json": [
		10180,
		3,
		10180
	],
	"./ko/ShopReviews.json": [
		64968,
		3,
		64968
	],
	"./ko/SmartReviews.json": [
		23168,
		3,
		23168
	],
	"./ko/TeamMembers.json": [
		1128,
		3,
		1128
	],
	"./ko/Welcome.json": [
		66048,
		3,
		66048
	],
	"./ko/Widgets.json": [
		50536,
		3,
		50536
	],
	"./ko/getStarted.json": [
		34336,
		3,
		34336
	],
	"./nl.json": [
		69706,
		3,
		69706
	],
	"./nl/Account.json": [
		31350,
		3,
		31350
	],
	"./nl/AdvancedWidgets.json": [
		1382,
		3,
		1382
	],
	"./nl/Agencies.json": [
		85610,
		3,
		85610
	],
	"./nl/Analytics.json": [
		52100,
		3,
		52100
	],
	"./nl/AutoQA.json": [
		38864,
		3,
		38864
	],
	"./nl/BulkOrderPicker.json": [
		29408,
		3,
		29408
	],
	"./nl/Common.json": [
		97472,
		3,
		97472
	],
	"./nl/ConfigurationWizard.json": [
		55488,
		3,
		55488
	],
	"./nl/Core/Errors.json": [
		94264,
		3,
		94264
	],
	"./nl/Core/Footer.json": [
		26872,
		3,
		26872
	],
	"./nl/Core/Recurring.json": [
		60728,
		3,
		60728
	],
	"./nl/Core/Toolbar.json": [
		57112,
		3,
		57112
	],
	"./nl/Coupons.json": [
		98248,
		3,
		98248
	],
	"./nl/CreatorTemplate.json": [
		28312,
		3,
		28312
	],
	"./nl/CustomizePlugin.json": [
		57982,
		3,
		57982
	],
	"./nl/Drawer.json": [
		1520,
		3,
		1520
	],
	"./nl/Email.json": [
		57995,
		3,
		57995
	],
	"./nl/GroupAdd.json": [
		84984,
		3,
		84984
	],
	"./nl/GroupEdit.json": [
		43644,
		3,
		43644
	],
	"./nl/HelpAndTutorials.json": [
		47152,
		3,
		47152
	],
	"./nl/HelpVideos.json": [
		53224,
		3,
		53224
	],
	"./nl/Home.json": [
		67948,
		3,
		67948
	],
	"./nl/ImportReviews.json": [
		18320,
		3,
		18320
	],
	"./nl/Integration.json": [
		43010,
		3,
		43010
	],
	"./nl/LinkProducts.json": [
		51352,
		3,
		51352
	],
	"./nl/LinkShops.json": [
		2136,
		3,
		2136
	],
	"./nl/MigrateReviews.json": [
		56816,
		3,
		56816
	],
	"./nl/NewOnboarding.json": [
		86754,
		3,
		86754
	],
	"./nl/Onboarding.json": [
		97412,
		3,
		97412
	],
	"./nl/Permissions.json": [
		75252,
		3,
		75252
	],
	"./nl/PlanPicker.json": [
		14944,
		3,
		14944
	],
	"./nl/Questions.json": [
		98624,
		3,
		98624
	],
	"./nl/Referral.json": [
		95139,
		3,
		95139
	],
	"./nl/RequestViaLink.json": [
		64156,
		3,
		64156
	],
	"./nl/ReviewCard.json": [
		26058,
		3,
		26058
	],
	"./nl/ReviewRequests.json": [
		11072,
		3,
		11072
	],
	"./nl/ReviewRequestsConfiguration.json": [
		36244,
		3,
		36244
	],
	"./nl/Reviews.json": [
		74778,
		3,
		74778
	],
	"./nl/Seo.json": [
		14730,
		3,
		14730
	],
	"./nl/Settings.json": [
		32328,
		3,
		32328
	],
	"./nl/ShopReviews.json": [
		72976,
		3,
		72976
	],
	"./nl/SmartReviews.json": [
		19012,
		3,
		19012
	],
	"./nl/TeamMembers.json": [
		10680,
		3,
		10680
	],
	"./nl/Welcome.json": [
		69202,
		3,
		69202
	],
	"./nl/Widgets.json": [
		85340,
		3,
		85340
	],
	"./nl/getStarted.json": [
		80608,
		3,
		80608
	],
	"./no.json": [
		87427,
		3,
		87427
	],
	"./no/Account.json": [
		2208,
		3,
		2208
	],
	"./no/AdvancedWidgets.json": [
		4096,
		3,
		4096
	],
	"./no/Agencies.json": [
		32728,
		3,
		32728
	],
	"./no/Analytics.json": [
		87230,
		3,
		87230
	],
	"./no/AutoQA.json": [
		91136,
		3,
		91136
	],
	"./no/BulkOrderPicker.json": [
		26192,
		3,
		26192
	],
	"./no/Common.json": [
		35608,
		3,
		35608
	],
	"./no/ConfigurationWizard.json": [
		6304,
		3,
		6304
	],
	"./no/Core/Errors.json": [
		46904,
		3,
		46904
	],
	"./no/Core/Footer.json": [
		19724,
		3,
		19724
	],
	"./no/Core/Recurring.json": [
		44216,
		3,
		44216
	],
	"./no/Core/Toolbar.json": [
		74216,
		3,
		74216
	],
	"./no/Coupons.json": [
		57912,
		3,
		57912
	],
	"./no/CreatorTemplate.json": [
		67000,
		3,
		67000
	],
	"./no/CustomizePlugin.json": [
		72088,
		3,
		72088
	],
	"./no/Drawer.json": [
		80136,
		3,
		80136
	],
	"./no/Email.json": [
		59464,
		3,
		59464
	],
	"./no/GroupAdd.json": [
		63352,
		3,
		63352
	],
	"./no/GroupEdit.json": [
		66362,
		3,
		66362
	],
	"./no/HelpAndTutorials.json": [
		79872,
		3,
		35112
	],
	"./no/HelpVideos.json": [
		16762,
		3,
		16762
	],
	"./no/Home.json": [
		20216,
		3,
		20216
	],
	"./no/ImportReviews.json": [
		8960,
		3,
		8960
	],
	"./no/Integration.json": [
		34690,
		3,
		34690
	],
	"./no/LinkProducts.json": [
		30502,
		3,
		30502
	],
	"./no/LinkShops.json": [
		5280,
		3,
		5280
	],
	"./no/MigrateReviews.json": [
		44916,
		3,
		44916
	],
	"./no/NewOnboarding.json": [
		31352,
		3,
		8972
	],
	"./no/Onboarding.json": [
		19282,
		3,
		19282
	],
	"./no/Permissions.json": [
		28824,
		3,
		51208
	],
	"./no/PlanPicker.json": [
		29115,
		3,
		29115
	],
	"./no/Questions.json": [
		68688,
		3,
		68688
	],
	"./no/Referral.json": [
		85980,
		3,
		85980
	],
	"./no/RequestViaLink.json": [
		42416,
		3,
		42416
	],
	"./no/ReviewCard.json": [
		85888,
		3,
		85888
	],
	"./no/ReviewRequests.json": [
		28718,
		3,
		28718
	],
	"./no/ReviewRequestsConfiguration.json": [
		39312,
		3,
		39312
	],
	"./no/Reviews.json": [
		20520,
		3,
		20520
	],
	"./no/Seo.json": [
		76306,
		3,
		76306
	],
	"./no/Settings.json": [
		73176,
		3,
		73176
	],
	"./no/ShopReviews.json": [
		26592,
		3,
		26592
	],
	"./no/SmartReviews.json": [
		57008,
		3,
		57008
	],
	"./no/TeamMembers.json": [
		54056,
		3,
		54056
	],
	"./no/Welcome.json": [
		24760,
		3,
		24760
	],
	"./no/Widgets.json": [
		52376,
		3,
		52376
	],
	"./no/getStarted.json": [
		28408,
		3,
		28408
	],
	"./pl.json": [
		10696,
		3,
		10696
	],
	"./pl/Account.json": [
		29546,
		3,
		29546
	],
	"./pl/AdvancedWidgets.json": [
		19328,
		3,
		19328
	],
	"./pl/Agencies.json": [
		40042,
		3,
		40042
	],
	"./pl/Analytics.json": [
		36776,
		3,
		36776
	],
	"./pl/AutoQA.json": [
		71556,
		3,
		71556
	],
	"./pl/BulkOrderPicker.json": [
		82630,
		3,
		82630
	],
	"./pl/Common.json": [
		35612,
		3,
		35612
	],
	"./pl/ConfigurationWizard.json": [
		12598,
		3,
		12598
	],
	"./pl/Core/Errors.json": [
		40350,
		3,
		40350
	],
	"./pl/Core/Footer.json": [
		60320,
		3,
		60320
	],
	"./pl/Core/Recurring.json": [
		4110,
		3,
		4110
	],
	"./pl/Core/Toolbar.json": [
		22304,
		3,
		22304
	],
	"./pl/Coupons.json": [
		82624,
		3,
		82624
	],
	"./pl/CreatorTemplate.json": [
		83834,
		3,
		83834
	],
	"./pl/CustomizePlugin.json": [
		39468,
		3,
		39468
	],
	"./pl/Drawer.json": [
		35328,
		3,
		35328
	],
	"./pl/Email.json": [
		17920,
		3,
		17920
	],
	"./pl/GroupAdd.json": [
		21216,
		3,
		21216
	],
	"./pl/GroupEdit.json": [
		38368,
		3,
		38368
	],
	"./pl/HelpAndTutorials.json": [
		15635,
		3,
		15635
	],
	"./pl/HelpVideos.json": [
		89724,
		3,
		89724
	],
	"./pl/Home.json": [
		98928,
		3,
		98928
	],
	"./pl/ImportReviews.json": [
		17728,
		3,
		17728
	],
	"./pl/Integration.json": [
		93392,
		3,
		93392
	],
	"./pl/LinkProducts.json": [
		41804,
		3,
		41804
	],
	"./pl/LinkShops.json": [
		3228,
		3,
		3228
	],
	"./pl/MigrateReviews.json": [
		81092,
		3,
		81092
	],
	"./pl/NewOnboarding.json": [
		94876,
		3,
		94876
	],
	"./pl/Onboarding.json": [
		87016,
		3,
		87016
	],
	"./pl/Permissions.json": [
		28992,
		3,
		6612
	],
	"./pl/PlanPicker.json": [
		4472,
		3,
		4472
	],
	"./pl/Questions.json": [
		16648,
		3,
		16648
	],
	"./pl/Referral.json": [
		72720,
		3,
		72720
	],
	"./pl/RequestViaLink.json": [
		89516,
		3,
		89516
	],
	"./pl/ReviewCard.json": [
		93872,
		3,
		93872
	],
	"./pl/ReviewRequests.json": [
		49796,
		3,
		49796
	],
	"./pl/ReviewRequestsConfiguration.json": [
		88608,
		3,
		88608
	],
	"./pl/Reviews.json": [
		83078,
		3,
		83078
	],
	"./pl/Seo.json": [
		30288,
		3,
		30288
	],
	"./pl/Settings.json": [
		96048,
		3,
		96048
	],
	"./pl/ShopReviews.json": [
		8286,
		3,
		8286
	],
	"./pl/SmartReviews.json": [
		22424,
		3,
		22424
	],
	"./pl/TeamMembers.json": [
		4024,
		3,
		4024
	],
	"./pl/Welcome.json": [
		5816,
		3,
		5816
	],
	"./pl/Widgets.json": [
		87976,
		3,
		87976
	],
	"./pl/getStarted.json": [
		48256,
		3,
		48256
	],
	"./pt.json": [
		61012,
		3,
		83392
	],
	"./pt/Account.json": [
		83536,
		3,
		83536
	],
	"./pt/AdvancedWidgets.json": [
		54571,
		3,
		76952
	],
	"./pt/Agencies.json": [
		18050,
		3,
		18050
	],
	"./pt/Analytics.json": [
		8328,
		3,
		8328
	],
	"./pt/AutoQA.json": [
		6232,
		3,
		6232
	],
	"./pt/BulkOrderPicker.json": [
		55622,
		3,
		55622
	],
	"./pt/Common.json": [
		93352,
		3,
		93352
	],
	"./pt/ConfigurationWizard.json": [
		18708,
		3,
		18708
	],
	"./pt/Core/Errors.json": [
		72356,
		3,
		72356
	],
	"./pt/Core/Footer.json": [
		13520,
		3,
		13520
	],
	"./pt/Core/Recurring.json": [
		67800,
		3,
		67800
	],
	"./pt/Core/Toolbar.json": [
		32692,
		3,
		32692
	],
	"./pt/Coupons.json": [
		82088,
		3,
		82088
	],
	"./pt/CreatorTemplate.json": [
		85952,
		3,
		85952
	],
	"./pt/CustomizePlugin.json": [
		12040,
		3,
		12040
	],
	"./pt/Drawer.json": [
		23864,
		3,
		23864
	],
	"./pt/Email.json": [
		68744,
		3,
		68744
	],
	"./pt/GroupAdd.json": [
		21928,
		3,
		21928
	],
	"./pt/GroupEdit.json": [
		86808,
		3,
		86808
	],
	"./pt/HelpAndTutorials.json": [
		90888,
		3,
		90888
	],
	"./pt/HelpVideos.json": [
		74556,
		3,
		74556
	],
	"./pt/Home.json": [
		73280,
		3,
		73280
	],
	"./pt/ImportReviews.json": [
		60372,
		3,
		60372
	],
	"./pt/Integration.json": [
		15816,
		3,
		15816
	],
	"./pt/LinkProducts.json": [
		89872,
		3,
		89872
	],
	"./pt/LinkShops.json": [
		2952,
		3,
		2952
	],
	"./pt/MigrateReviews.json": [
		26418,
		3,
		26418
	],
	"./pt/NewOnboarding.json": [
		36308,
		3,
		36308
	],
	"./pt/Onboarding.json": [
		54859,
		3,
		54859
	],
	"./pt/Permissions.json": [
		12320,
		3,
		12320
	],
	"./pt/PlanPicker.json": [
		35032,
		3,
		35032
	],
	"./pt/Questions.json": [
		87670,
		3,
		87670
	],
	"./pt/Referral.json": [
		74112,
		3,
		74112
	],
	"./pt/RequestViaLink.json": [
		32720,
		3,
		32720
	],
	"./pt/ReviewCard.json": [
		38622,
		3,
		38622
	],
	"./pt/ReviewRequests.json": [
		54115,
		3,
		76496
	],
	"./pt/ReviewRequestsConfiguration.json": [
		45768,
		3,
		45768
	],
	"./pt/Reviews.json": [
		45758,
		3,
		45758
	],
	"./pt/Seo.json": [
		74808,
		3,
		74808
	],
	"./pt/Settings.json": [
		86944,
		3,
		86944
	],
	"./pt/ShopReviews.json": [
		79384,
		3,
		79384
	],
	"./pt/SmartReviews.json": [
		96368,
		3,
		96368
	],
	"./pt/TeamMembers.json": [
		9632,
		3,
		9632
	],
	"./pt/Welcome.json": [
		93200,
		3,
		93200
	],
	"./pt/Widgets.json": [
		28536,
		3,
		28536
	],
	"./pt/getStarted.json": [
		4088,
		3,
		4088
	],
	"./pt_BR.json": [
		24236,
		3,
		24236
	],
	"./pt_BR/Account.json": [
		75288,
		3,
		75288
	],
	"./pt_BR/AdvancedWidgets.json": [
		54844,
		3,
		54844
	],
	"./pt_BR/Agencies.json": [
		72978,
		3,
		72978
	],
	"./pt_BR/Analytics.json": [
		99048,
		3,
		99048
	],
	"./pt_BR/AutoQA.json": [
		99696,
		3,
		99696
	],
	"./pt_BR/BulkOrderPicker.json": [
		90920,
		3,
		90920
	],
	"./pt_BR/Common.json": [
		15416,
		3,
		15416
	],
	"./pt_BR/ConfigurationWizard.json": [
		76406,
		3,
		76406
	],
	"./pt_BR/Core/Errors.json": [
		91964,
		3,
		91964
	],
	"./pt_BR/Core/Footer.json": [
		56992,
		3,
		56992
	],
	"./pt_BR/Core/Recurring.json": [
		62246,
		3,
		62246
	],
	"./pt_BR/Core/Toolbar.json": [
		10092,
		3,
		32472
	],
	"./pt_BR/Coupons.json": [
		83672,
		3,
		83672
	],
	"./pt_BR/CreatorTemplate.json": [
		55432,
		3,
		55432
	],
	"./pt_BR/CustomizePlugin.json": [
		23280,
		3,
		23280
	],
	"./pt_BR/Drawer.json": [
		33048,
		3,
		33048
	],
	"./pt_BR/Email.json": [
		18912,
		3,
		18912
	],
	"./pt_BR/GroupAdd.json": [
		95136,
		3,
		95136
	],
	"./pt_BR/GroupEdit.json": [
		32024,
		3,
		32024
	],
	"./pt_BR/HelpAndTutorials.json": [
		27696,
		3,
		27696
	],
	"./pt_BR/HelpVideos.json": [
		48992,
		3,
		48992
	],
	"./pt_BR/Home.json": [
		40816,
		3,
		40816
	],
	"./pt_BR/ImportReviews.json": [
		78880,
		3,
		78880
	],
	"./pt_BR/Integration.json": [
		44667,
		3,
		67048
	],
	"./pt_BR/LinkProducts.json": [
		42168,
		3,
		42168
	],
	"./pt_BR/LinkShops.json": [
		16264,
		3,
		16264
	],
	"./pt_BR/MigrateReviews.json": [
		78458,
		3,
		78458
	],
	"./pt_BR/NewOnboarding.json": [
		57492,
		3,
		57492
	],
	"./pt_BR/Onboarding.json": [
		30968,
		3,
		30968
	],
	"./pt_BR/Permissions.json": [
		38536,
		3,
		38536
	],
	"./pt_BR/PlanPicker.json": [
		18572,
		3,
		18572
	],
	"./pt_BR/Questions.json": [
		92394,
		3,
		92394
	],
	"./pt_BR/Referral.json": [
		30632,
		3,
		30632
	],
	"./pt_BR/RequestViaLink.json": [
		16354,
		3,
		16354
	],
	"./pt_BR/ReviewCard.json": [
		27080,
		3,
		27080
	],
	"./pt_BR/ReviewRequests.json": [
		97683,
		3,
		97683
	],
	"./pt_BR/ReviewRequestsConfiguration.json": [
		67915,
		3,
		90296
	],
	"./pt_BR/Reviews.json": [
		31106,
		3,
		31106
	],
	"./pt_BR/Seo.json": [
		33200,
		3,
		33200
	],
	"./pt_BR/Settings.json": [
		25288,
		3,
		25288
	],
	"./pt_BR/ShopReviews.json": [
		32568,
		3,
		32568
	],
	"./pt_BR/SmartReviews.json": [
		64450,
		3,
		64450
	],
	"./pt_BR/TeamMembers.json": [
		8516,
		3,
		8516
	],
	"./pt_BR/Welcome.json": [
		29340,
		3,
		29340
	],
	"./pt_BR/Widgets.json": [
		69334,
		3,
		69334
	],
	"./pt_BR/getStarted.json": [
		70600,
		3,
		70600
	],
	"./pt_PT.json": [
		10876,
		3,
		10876
	],
	"./pt_PT/Account.json": [
		17664,
		3,
		17664
	],
	"./pt_PT/AdvancedWidgets.json": [
		85392,
		3,
		63012
	],
	"./pt_PT/Agencies.json": [
		4474,
		3,
		4474
	],
	"./pt_PT/Analytics.json": [
		59400,
		3,
		59400
	],
	"./pt_PT/AutoQA.json": [
		688,
		3,
		688
	],
	"./pt_PT/BulkOrderPicker.json": [
		88872,
		3,
		88872
	],
	"./pt_PT/Common.json": [
		58976,
		3,
		58976
	],
	"./pt_PT/ConfigurationWizard.json": [
		62936,
		3,
		62936
	],
	"./pt_PT/Core/Errors.json": [
		67144,
		3,
		67144
	],
	"./pt_PT/Core/Footer.json": [
		57232,
		3,
		57232
	],
	"./pt_PT/Core/Recurring.json": [
		34272,
		3,
		34272
	],
	"./pt_PT/Core/Toolbar.json": [
		25496,
		3,
		25496
	],
	"./pt_PT/Coupons.json": [
		38410,
		3,
		38410
	],
	"./pt_PT/CreatorTemplate.json": [
		76920,
		3,
		76920
	],
	"./pt_PT/CustomizePlugin.json": [
		91400,
		3,
		91400
	],
	"./pt_PT/Drawer.json": [
		22240,
		3,
		22240
	],
	"./pt_PT/Email.json": [
		80110,
		3,
		80110
	],
	"./pt_PT/GroupAdd.json": [
		64344,
		3,
		64344
	],
	"./pt_PT/GroupEdit.json": [
		75474,
		3,
		75474
	],
	"./pt_PT/HelpAndTutorials.json": [
		97284,
		3,
		97284
	],
	"./pt_PT/HelpVideos.json": [
		39520,
		3,
		39520
	],
	"./pt_PT/Home.json": [
		71388,
		3,
		71388
	],
	"./pt_PT/ImportReviews.json": [
		27524,
		3,
		27524
	],
	"./pt_PT/Integration.json": [
		19446,
		3,
		19446
	],
	"./pt_PT/LinkProducts.json": [
		640,
		3,
		640
	],
	"./pt_PT/LinkShops.json": [
		34684,
		3,
		34684
	],
	"./pt_PT/MigrateReviews.json": [
		51096,
		3,
		51096
	],
	"./pt_PT/NewOnboarding.json": [
		16464,
		3,
		16464
	],
	"./pt_PT/Onboarding.json": [
		28752,
		3,
		28752
	],
	"./pt_PT/Permissions.json": [
		77768,
		3,
		77768
	],
	"./pt_PT/PlanPicker.json": [
		4020,
		3,
		26400
	],
	"./pt_PT/Questions.json": [
		33160,
		3,
		33160
	],
	"./pt_PT/Referral.json": [
		48924,
		3,
		48924
	],
	"./pt_PT/RequestViaLink.json": [
		54672,
		3,
		54672
	],
	"./pt_PT/ReviewCard.json": [
		24792,
		3,
		24792
	],
	"./pt_PT/ReviewRequests.json": [
		14770,
		3,
		14770
	],
	"./pt_PT/ReviewRequestsConfiguration.json": [
		69844,
		3,
		69844
	],
	"./pt_PT/Reviews.json": [
		44564,
		3,
		44564
	],
	"./pt_PT/Seo.json": [
		2018,
		3,
		2018
	],
	"./pt_PT/Settings.json": [
		15052,
		3,
		15052
	],
	"./pt_PT/ShopReviews.json": [
		95216,
		3,
		95216
	],
	"./pt_PT/SmartReviews.json": [
		92864,
		3,
		92864
	],
	"./pt_PT/TeamMembers.json": [
		40850,
		3,
		40850
	],
	"./pt_PT/Welcome.json": [
		16240,
		3,
		16240
	],
	"./pt_PT/Widgets.json": [
		78976,
		3,
		78976
	],
	"./pt_PT/getStarted.json": [
		17090,
		3,
		17090
	],
	"./sv.json": [
		43450,
		3,
		43450
	],
	"./sv/Account.json": [
		52388,
		3,
		52388
	],
	"./sv/AdvancedWidgets.json": [
		3602,
		3,
		3602
	],
	"./sv/Agencies.json": [
		364,
		3,
		364
	],
	"./sv/Analytics.json": [
		62976,
		3,
		62976
	],
	"./sv/AutoQA.json": [
		39024,
		3,
		39024
	],
	"./sv/BulkOrderPicker.json": [
		74200,
		3,
		74200
	],
	"./sv/Common.json": [
		37432,
		3,
		37432
	],
	"./sv/ConfigurationWizard.json": [
		98338,
		3,
		98338
	],
	"./sv/Core/Errors.json": [
		22306,
		3,
		22306
	],
	"./sv/Core/Footer.json": [
		14504,
		3,
		14504
	],
	"./sv/Core/Recurring.json": [
		56874,
		3,
		56874
	],
	"./sv/Core/Toolbar.json": [
		30016,
		3,
		30016
	],
	"./sv/Coupons.json": [
		77619,
		3,
		77619
	],
	"./sv/CreatorTemplate.json": [
		60608,
		3,
		60608
	],
	"./sv/CustomizePlugin.json": [
		76954,
		3,
		76954
	],
	"./sv/Drawer.json": [
		56844,
		3,
		56844
	],
	"./sv/Email.json": [
		1952,
		3,
		1952
	],
	"./sv/GroupAdd.json": [
		70123,
		3,
		70123
	],
	"./sv/GroupEdit.json": [
		52792,
		3,
		52792
	],
	"./sv/HelpAndTutorials.json": [
		93120,
		3,
		93120
	],
	"./sv/HelpVideos.json": [
		89768,
		3,
		89768
	],
	"./sv/Home.json": [
		64888,
		3,
		64888
	],
	"./sv/ImportReviews.json": [
		48824,
		3,
		48824
	],
	"./sv/Integration.json": [
		9904,
		3,
		9904
	],
	"./sv/LinkProducts.json": [
		50658,
		3,
		50658
	],
	"./sv/LinkShops.json": [
		25432,
		3,
		25432
	],
	"./sv/MigrateReviews.json": [
		12468,
		3,
		12468
	],
	"./sv/NewOnboarding.json": [
		56952,
		3,
		56952
	],
	"./sv/Onboarding.json": [
		47042,
		3,
		47042
	],
	"./sv/Permissions.json": [
		65240,
		3,
		65240
	],
	"./sv/PlanPicker.json": [
		49114,
		3,
		49114
	],
	"./sv/Questions.json": [
		65364,
		3,
		65364
	],
	"./sv/Referral.json": [
		73504,
		3,
		73504
	],
	"./sv/RequestViaLink.json": [
		4768,
		3,
		4768
	],
	"./sv/ReviewCard.json": [
		42854,
		3,
		42854
	],
	"./sv/ReviewRequests.json": [
		23680,
		3,
		23680
	],
	"./sv/ReviewRequestsConfiguration.json": [
		16640,
		3,
		16640
	],
	"./sv/Reviews.json": [
		61536,
		3,
		61536
	],
	"./sv/Seo.json": [
		10896,
		3,
		10896
	],
	"./sv/Settings.json": [
		2528,
		3,
		2528
	],
	"./sv/ShopReviews.json": [
		96150,
		3,
		96150
	],
	"./sv/SmartReviews.json": [
		32844,
		3,
		32844
	],
	"./sv/TeamMembers.json": [
		35384,
		3,
		35384
	],
	"./sv/Welcome.json": [
		13300,
		3,
		13300
	],
	"./sv/Widgets.json": [
		42088,
		3,
		42088
	],
	"./sv/getStarted.json": [
		1936,
		3,
		1936
	],
	"./th.json": [
		49272,
		3,
		49272
	],
	"./th/Account.json": [
		77144,
		3,
		77144
	],
	"./th/AdvancedWidgets.json": [
		26128,
		3,
		26128
	],
	"./th/Agencies.json": [
		95744,
		3,
		95744
	],
	"./th/Analytics.json": [
		54008,
		3,
		54008
	],
	"./th/AutoQA.json": [
		33472,
		3,
		33472
	],
	"./th/BulkOrderPicker.json": [
		984,
		3,
		984
	],
	"./th/Common.json": [
		65480,
		3,
		65480
	],
	"./th/ConfigurationWizard.json": [
		22272,
		3,
		22272
	],
	"./th/Core/Errors.json": [
		83872,
		3,
		83872
	],
	"./th/Core/Footer.json": [
		3624,
		3,
		3624
	],
	"./th/Core/Recurring.json": [
		85722,
		3,
		85722
	],
	"./th/Core/Toolbar.json": [
		77492,
		3,
		77492
	],
	"./th/Coupons.json": [
		49714,
		3,
		49714
	],
	"./th/CreatorTemplate.json": [
		90816,
		3,
		90816
	],
	"./th/CustomizePlugin.json": [
		96184,
		3,
		96184
	],
	"./th/Drawer.json": [
		26746,
		3,
		26746
	],
	"./th/Email.json": [
		74354,
		3,
		74354
	],
	"./th/GroupAdd.json": [
		18896,
		3,
		18896
	],
	"./th/GroupEdit.json": [
		23704,
		3,
		23704
	],
	"./th/HelpAndTutorials.json": [
		32756,
		3,
		32756
	],
	"./th/HelpVideos.json": [
		4760,
		3,
		4760
	],
	"./th/Home.json": [
		14520,
		3,
		14520
	],
	"./th/ImportReviews.json": [
		7144,
		3,
		7144
	],
	"./th/Integration.json": [
		35936,
		3,
		35936
	],
	"./th/LinkProducts.json": [
		49480,
		3,
		49480
	],
	"./th/LinkShops.json": [
		35598,
		3,
		35598
	],
	"./th/MigrateReviews.json": [
		42204,
		3,
		42204
	],
	"./th/NewOnboarding.json": [
		67724,
		3,
		90104
	],
	"./th/Onboarding.json": [
		5112,
		3,
		5112
	],
	"./th/Permissions.json": [
		24384,
		3,
		2004
	],
	"./th/PlanPicker.json": [
		37912,
		3,
		37912
	],
	"./th/Questions.json": [
		34648,
		3,
		34648
	],
	"./th/Referral.json": [
		93176,
		3,
		93176
	],
	"./th/RequestViaLink.json": [
		20880,
		3,
		20880
	],
	"./th/ReviewCard.json": [
		65896,
		3,
		65896
	],
	"./th/ReviewRequests.json": [
		56160,
		3,
		56160
	],
	"./th/ReviewRequestsConfiguration.json": [
		4624,
		3,
		4624
	],
	"./th/Reviews.json": [
		48648,
		3,
		48648
	],
	"./th/Seo.json": [
		40960,
		3,
		40960
	],
	"./th/Settings.json": [
		18442,
		3,
		18442
	],
	"./th/ShopReviews.json": [
		33704,
		3,
		33704
	],
	"./th/SmartReviews.json": [
		77856,
		3,
		77856
	],
	"./th/TeamMembers.json": [
		13024,
		3,
		13024
	],
	"./th/Welcome.json": [
		61232,
		3,
		61232
	],
	"./th/Widgets.json": [
		14122,
		3,
		14122
	],
	"./th/getStarted.json": [
		97944,
		3,
		97944
	],
	"./tr.json": [
		74812,
		3,
		74812
	],
	"./tr/Account.json": [
		77720,
		3,
		77720
	],
	"./tr/AdvancedWidgets.json": [
		1230,
		3,
		1230
	],
	"./tr/Agencies.json": [
		6528,
		3,
		6528
	],
	"./tr/Analytics.json": [
		35382,
		3,
		35382
	],
	"./tr/AutoQA.json": [
		41448,
		3,
		41448
	],
	"./tr/BulkOrderPicker.json": [
		78240,
		3,
		78240
	],
	"./tr/Common.json": [
		23496,
		3,
		23496
	],
	"./tr/ConfigurationWizard.json": [
		78096,
		3,
		78096
	],
	"./tr/Core/Errors.json": [
		76540,
		3,
		76540
	],
	"./tr/Core/Footer.json": [
		91472,
		3,
		91472
	],
	"./tr/Core/Recurring.json": [
		48264,
		3,
		48264
	],
	"./tr/Core/Toolbar.json": [
		43672,
		3,
		43672
	],
	"./tr/Coupons.json": [
		68248,
		3,
		68248
	],
	"./tr/CreatorTemplate.json": [
		50736,
		3,
		50736
	],
	"./tr/CustomizePlugin.json": [
		30986,
		3,
		30986
	],
	"./tr/Drawer.json": [
		50976,
		3,
		50976
	],
	"./tr/Email.json": [
		55083,
		3,
		77464
	],
	"./tr/GroupAdd.json": [
		46240,
		3,
		46240
	],
	"./tr/GroupEdit.json": [
		69048,
		3,
		69048
	],
	"./tr/HelpAndTutorials.json": [
		70304,
		3,
		70304
	],
	"./tr/HelpVideos.json": [
		27875,
		3,
		50256
	],
	"./tr/Home.json": [
		6314,
		3,
		6314
	],
	"./tr/ImportReviews.json": [
		74642,
		3,
		74642
	],
	"./tr/Integration.json": [
		74416,
		3,
		74416
	],
	"./tr/LinkProducts.json": [
		82206,
		3,
		82206
	],
	"./tr/LinkShops.json": [
		71192,
		3,
		71192
	],
	"./tr/MigrateReviews.json": [
		51088,
		3,
		51088
	],
	"./tr/NewOnboarding.json": [
		38454,
		3,
		38454
	],
	"./tr/Onboarding.json": [
		55724,
		3,
		55724
	],
	"./tr/Permissions.json": [
		63524,
		3,
		63524
	],
	"./tr/PlanPicker.json": [
		10152,
		3,
		10152
	],
	"./tr/Questions.json": [
		58948,
		3,
		81328
	],
	"./tr/Referral.json": [
		97054,
		3,
		97054
	],
	"./tr/RequestViaLink.json": [
		70264,
		3,
		70264
	],
	"./tr/ReviewCard.json": [
		89200,
		3,
		89200
	],
	"./tr/ReviewRequests.json": [
		59704,
		3,
		59704
	],
	"./tr/ReviewRequestsConfiguration.json": [
		66620,
		3,
		66620
	],
	"./tr/Reviews.json": [
		2360,
		3,
		2360
	],
	"./tr/Seo.json": [
		15016,
		3,
		15016
	],
	"./tr/Settings.json": [
		59292,
		3,
		59292
	],
	"./tr/ShopReviews.json": [
		29560,
		3,
		29560
	],
	"./tr/SmartReviews.json": [
		13048,
		3,
		13048
	],
	"./tr/TeamMembers.json": [
		92748,
		3,
		92748
	],
	"./tr/Welcome.json": [
		85508,
		3,
		85508
	],
	"./tr/Widgets.json": [
		328,
		3,
		328
	],
	"./tr/getStarted.json": [
		96312,
		3,
		96312
	],
	"./zh_CN.json": [
		80462,
		3,
		80462
	],
	"./zh_CN/Account.json": [
		964,
		3,
		964
	],
	"./zh_CN/AdvancedWidgets.json": [
		69776,
		3,
		69776
	],
	"./zh_CN/Agencies.json": [
		14370,
		3,
		14370
	],
	"./zh_CN/Analytics.json": [
		10648,
		3,
		10648
	],
	"./zh_CN/AutoQA.json": [
		93328,
		3,
		93328
	],
	"./zh_CN/BulkOrderPicker.json": [
		8972,
		3,
		31352
	],
	"./zh_CN/Common.json": [
		4640,
		3,
		4640
	],
	"./zh_CN/ConfigurationWizard.json": [
		13012,
		3,
		13012
	],
	"./zh_CN/Core/Errors.json": [
		25780,
		3,
		25780
	],
	"./zh_CN/Core/Footer.json": [
		16216,
		3,
		16216
	],
	"./zh_CN/Core/Recurring.json": [
		8176,
		3,
		8176
	],
	"./zh_CN/Core/Toolbar.json": [
		58824,
		3,
		58824
	],
	"./zh_CN/Coupons.json": [
		41672,
		3,
		41672
	],
	"./zh_CN/CreatorTemplate.json": [
		92672,
		3,
		92672
	],
	"./zh_CN/CustomizePlugin.json": [
		10448,
		3,
		10448
	],
	"./zh_CN/Drawer.json": [
		32934,
		3,
		32934
	],
	"./zh_CN/Email.json": [
		7384,
		3,
		7384
	],
	"./zh_CN/GroupAdd.json": [
		98280,
		3,
		98280
	],
	"./zh_CN/GroupEdit.json": [
		10928,
		3,
		10928
	],
	"./zh_CN/HelpAndTutorials.json": [
		50346,
		3,
		50346
	],
	"./zh_CN/HelpVideos.json": [
		17104,
		3,
		17104
	],
	"./zh_CN/Home.json": [
		93224,
		3,
		93224
	],
	"./zh_CN/ImportReviews.json": [
		17792,
		3,
		17792
	],
	"./zh_CN/Integration.json": [
		4802,
		3,
		4802
	],
	"./zh_CN/LinkProducts.json": [
		32060,
		3,
		32060
	],
	"./zh_CN/LinkShops.json": [
		45616,
		3,
		45616
	],
	"./zh_CN/MigrateReviews.json": [
		67620,
		3,
		67620
	],
	"./zh_CN/NewOnboarding.json": [
		65091,
		3,
		87472
	],
	"./zh_CN/Onboarding.json": [
		48948,
		3,
		48948
	],
	"./zh_CN/Permissions.json": [
		9872,
		3,
		9872
	],
	"./zh_CN/PlanPicker.json": [
		39264,
		3,
		39264
	],
	"./zh_CN/Questions.json": [
		57040,
		3,
		57040
	],
	"./zh_CN/Referral.json": [
		77371,
		3,
		99752
	],
	"./zh_CN/RequestViaLink.json": [
		37792,
		3,
		37792
	],
	"./zh_CN/ReviewCard.json": [
		83924,
		3,
		61544
	],
	"./zh_CN/ReviewRequests.json": [
		36416,
		3,
		36416
	],
	"./zh_CN/ReviewRequestsConfiguration.json": [
		16478,
		3,
		16478
	],
	"./zh_CN/Reviews.json": [
		19428,
		3,
		19428
	],
	"./zh_CN/Seo.json": [
		26274,
		3,
		26274
	],
	"./zh_CN/Settings.json": [
		73528,
		3,
		73528
	],
	"./zh_CN/ShopReviews.json": [
		25387,
		3,
		25387
	],
	"./zh_CN/SmartReviews.json": [
		34536,
		3,
		34536
	],
	"./zh_CN/TeamMembers.json": [
		71688,
		3,
		71688
	],
	"./zh_CN/Welcome.json": [
		31904,
		3,
		31904
	],
	"./zh_CN/Widgets.json": [
		67328,
		3,
		67328
	],
	"./zh_CN/getStarted.json": [
		80784,
		3,
		80784
	],
	"./zh_TW.json": [
		61504,
		3,
		61504
	],
	"./zh_TW/Account.json": [
		63012,
		3,
		85392
	],
	"./zh_TW/AdvancedWidgets.json": [
		1536,
		3,
		1536
	],
	"./zh_TW/Agencies.json": [
		55070,
		3,
		55070
	],
	"./zh_TW/Analytics.json": [
		39440,
		3,
		39440
	],
	"./zh_TW/AutoQA.json": [
		72738,
		3,
		72738
	],
	"./zh_TW/BulkOrderPicker.json": [
		23948,
		3,
		46328
	],
	"./zh_TW/Common.json": [
		81368,
		3,
		81368
	],
	"./zh_TW/ConfigurationWizard.json": [
		43624,
		3,
		43624
	],
	"./zh_TW/Core/Errors.json": [
		24128,
		3,
		24128
	],
	"./zh_TW/Core/Footer.json": [
		88368,
		3,
		88368
	],
	"./zh_TW/Core/Recurring.json": [
		82800,
		3,
		82800
	],
	"./zh_TW/Core/Toolbar.json": [
		65440,
		3,
		65440
	],
	"./zh_TW/Coupons.json": [
		6416,
		3,
		6416
	],
	"./zh_TW/CreatorTemplate.json": [
		16467,
		3,
		16467
	],
	"./zh_TW/CustomizePlugin.json": [
		79468,
		3,
		79468
	],
	"./zh_TW/Drawer.json": [
		2640,
		3,
		2640
	],
	"./zh_TW/Email.json": [
		648,
		3,
		648
	],
	"./zh_TW/GroupAdd.json": [
		95952,
		3,
		95952
	],
	"./zh_TW/GroupEdit.json": [
		71604,
		3,
		71604
	],
	"./zh_TW/HelpAndTutorials.json": [
		1208,
		3,
		1208
	],
	"./zh_TW/HelpVideos.json": [
		6612,
		3,
		28992
	],
	"./zh_TW/Home.json": [
		3000,
		3,
		3000
	],
	"./zh_TW/ImportReviews.json": [
		50864,
		3,
		50864
	],
	"./zh_TW/Integration.json": [
		152,
		3,
		152
	],
	"./zh_TW/LinkProducts.json": [
		55480,
		3,
		55480
	],
	"./zh_TW/LinkShops.json": [
		49760,
		3,
		49760
	],
	"./zh_TW/MigrateReviews.json": [
		76554,
		3,
		76554
	],
	"./zh_TW/NewOnboarding.json": [
		80192,
		3,
		80192
	],
	"./zh_TW/Onboarding.json": [
		17683,
		3,
		40064
	],
	"./zh_TW/Permissions.json": [
		72536,
		3,
		72536
	],
	"./zh_TW/PlanPicker.json": [
		16984,
		3,
		16984
	],
	"./zh_TW/Questions.json": [
		5952,
		3,
		5952
	],
	"./zh_TW/Referral.json": [
		97988,
		3,
		97988
	],
	"./zh_TW/RequestViaLink.json": [
		74136,
		3,
		74136
	],
	"./zh_TW/ReviewCard.json": [
		47664,
		3,
		47664
	],
	"./zh_TW/ReviewRequests.json": [
		79696,
		3,
		79696
	],
	"./zh_TW/ReviewRequestsConfiguration.json": [
		2352,
		3,
		2352
	],
	"./zh_TW/Reviews.json": [
		69054,
		3,
		69054
	],
	"./zh_TW/Seo.json": [
		896,
		3,
		896
	],
	"./zh_TW/Settings.json": [
		13541,
		3,
		13541
	],
	"./zh_TW/ShopReviews.json": [
		94520,
		3,
		94520
	],
	"./zh_TW/SmartReviews.json": [
		14772,
		3,
		14772
	],
	"./zh_TW/TeamMembers.json": [
		56490,
		3,
		56490
	],
	"./zh_TW/Welcome.json": [
		95520,
		3,
		95520
	],
	"./zh_TW/Widgets.json": [
		64296,
		3,
		64296
	],
	"./zh_TW/getStarted.json": [
		80060,
		3,
		80060
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85824;
module.exports = webpackAsyncContext;